// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "flightsSortings__wrapper-BGSn5";
var _4 = "flightsSortings__route-X1t6R";
var _5 = "flightsSortings__route_roundedBottom---u-I";
var _6 = "flightsSortings__options-3z003";
var _7 = "flightsSortings__options_roundedTop-3LaeG";
export { _1 as "__esModule", _2 as "tablet", _3 as "flightsSortings__wrapper", _4 as "flightsSortings__route", _5 as "flightsSortings__route_roundedBottom", _6 as "flightsSortings__options", _7 as "flightsSortings__options_roundedTop" }
export default { "__esModule": _1, "tablet": _2, "flightsSortings__wrapper": _3, "flightsSortings__route": _4, "flightsSortings__route_roundedBottom": _5, "flightsSortings__options": _6, "flightsSortings__options_roundedTop": _7 }
